import { actionCreatorFactory } from "typescript-fsa";
import {sendlicensedata, mandant, modules} from '../typing/generalType';

const actionCreator = actionCreatorFactory("LicenseImnput");

const createLicense = actionCreator<{licensedata:sendlicensedata}>("LicenseImnput_CreateLIcense");
const SetMandant = actionCreator<{data:mandant[]}>("LicenseImnput_SetMandanat");
const SetModules = actionCreator<{data:modules[]}>("LicenseImnput_SetModules");
const SetFormData = actionCreator<{data:any, type:string}>("LicenseImnput_SetFormData");
const selectJob= actionCreator<{value:any, checked:any}>("LicenseImnput_ASET");
const SetToleranceDefault = actionCreator<{percent:number}>("LicenseImnput_SetToleranceDefault");
// state update action object
export const actions = {createLicense,SetFormData, SetMandant, SetModules, selectJob, SetToleranceDefault};